var _defs, _g, _path, _path2, _rect, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _g3, _path10, _ellipse, _ellipse2, _path11, _g4, _path12, _g5, _path13, _path14, _path15, _polygon, _polygon2, _polygon3, _path16, _path17, _ellipse3, _path18, _path19, _path20, _path21, _rect2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle2, _circle3, _path29, _path30, _rect3, _rect4, _path31, _path32, _path33, _path34, _ellipse4, _ellipse5, _path35, _path36, _g6, _text, _polygon4, _rect5, _path37, _path38, _path39, _path40, _path41, _path42, _circle4, _path43, _ellipse6, _ellipse7, _g7, _g8, _path44, _path45, _path46, _path47, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductAnalysis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 830.52,
    height: 709.6,
    viewBox: "0 0 830.52 709.6",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d75d4f5d-b700-42a6-92be-ed5e89a20100-298",
    x1: 530.5,
    y1: 797,
    x2: 530.5,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3aa49d9c-916f-4670-b217-2910ad731142-299",
    x1: 775.38,
    y1: 780.18,
    x2: 775.38,
    y2: 690.87,
    gradientTransform: "translate(-185.36 -86.58) rotate(-0.02)",
    xlinkHref: "#d75d4f5d-b700-42a6-92be-ed5e89a20100-298"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "29fdbb02-504d-40fc-8c8b-89d40eb7543b-300",
    x1: 775.39,
    y1: 790.34,
    x2: 775.39,
    y2: 758.68,
    gradientTransform: "translate(-0.62 0.82) rotate(-0.02)",
    xlinkHref: "#d75d4f5d-b700-42a6-92be-ed5e89a20100-298"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "875735f0-9451-4d18-8d7e-91aa5c4b50ca-301",
    x1: 670.31,
    y1: 643.75,
    x2: 670.31,
    y2: 543.2,
    gradientTransform: "translate(-0.62 0.82) rotate(-0.02)",
    xlinkHref: "#d75d4f5d-b700-42a6-92be-ed5e89a20100-298"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "86201932-e8e2-4080-9e8f-200c3a4020d8-302",
    x1: 878.8,
    y1: 643.75,
    x2: 878.8,
    y2: 543.2,
    gradientTransform: "translate(-0.62 0.82) rotate(-0.02)",
    xlinkHref: "#d75d4f5d-b700-42a6-92be-ed5e89a20100-298"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fba1422f-afa4-4f40-bd94-90e3ecf07106-303",
    x1: 774.55,
    y1: 727.25,
    x2: 774.55,
    y2: 515.55,
    gradientTransform: "translate(-0.62 0.82) rotate(-0.02)",
    xlinkHref: "#d75d4f5d-b700-42a6-92be-ed5e89a20100-298"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "product hunt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.85,414.74q-.06-2.17-.08-4.29a127.77,127.77,0,0,1,2.59-27.51c.29-1.3.61-2.57,1-3.81,5.33-8.39,11.66-23.52,12.22-38.15L666,228.63l-37.86-90.3-.53-.76c-1.88-8.58-9.2-34.54-28.36-31.29-20.36,3.45-2.19,34.48,2.12,41.37h0c.54.87.87,1.35.87,1.35l.24-.08,0,.08h-.26L623,225.14c-1.91,4.9-21.77,54.83-43.18,71.56-.21-26.14,2.62-59.48,3.77-71.88a37.82,37.82,0,0,0-1-13.06c-5.93-22.68-27-39.45-52.13-39.45A54.87,54.87,0,0,0,510.66,176a51.85,51.85,0,0,0-32.87,53c1.3,14.56,3.66,43.84,3.83,67.1-22.69-17.23-43.78-72.3-43.78-72.3L458.76,149s25.9-38.84,3-42.72c-19.3-3.27-26.59,23.09-28.4,31.48h0l-.49,1.54L395,227.66l74.93,114.59c.19,11.75,4,24.68,11.75,36.89a10.56,10.56,0,0,1,1.47,3.81,12.59,12.59,0,0,1,.18,1.38c-.39,7-5.22,15.68-10.64,25.21h0c-3.82,6.71-7.91,13.83-10.94,21.05-7,16.63-10.29,26-10.13,40-.2,16.93,5,40.28,15.11,93a116.26,116.26,0,0,1,16.38-5.4c2.73,24.17,5.76,57.1,3,64.43-3.66,9.85-6,57.36-4.2,82.71-12,15.51-17.23,15-17.23,15-13,3.89-12.32,11.7-9.55,16.88a16.16,16.16,0,0,0,3.88,5.56,6,6,0,0,1,1,1.1c.91,3.2-1.49,8.22-5.41,20-1.9,5.72-.67,11.07,1.61,15.51,3.59,8.07,11,13.53,11,13.53,8.13,2.43,10.79-.12,10.76-4.44,2.65,5.07,9.18,9.24,23.92,8.4,0,0,10.09.66,5-11.22s-2.52-60.06-2.52-60.06.48-6,1.28-15.09L575,631.9l9-73.7c5.76,8.14,9.68,10.52,23.15,11.25,0,0-.22-.69-.62-2l.62,0S578.65,478.18,576.85,414.74Zm-52,140.95a61.44,61.44,0,0,1,12.77,3.72l.9,5.17-3.78,64.68A100.71,100.71,0,0,0,512.37,650c1.54-10.46,3.16-18.45,4.68-20.75C520.8,623.59,523.45,582.74,524.81,555.69ZM478,773.13a24,24,0,0,0-1.56,8.29c-.29-.78-.62-1.57-1-2.35-2.33-5.28,4.43-24.08,10-37.75A116.71,116.71,0,0,1,483.63,756Z",
    transform: "translate(-184.74 -87.4)",
    fill: "url(#d75d4f5d-b700-42a6-92be-ed5e89a20100-298)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M627,144.31s-5.74-37.29-27.73-33.46,2.87,42.07,2.87,42.07Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fdb797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.58,144.31s5.74-37.29,27.73-33.46-2.87,42.07-2.87,42.07Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fdb797"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 335.15,
    y: 395.36,
    width: 47.8,
    height: 37.29,
    fill: "#535461"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M584.22,227.56a38.18,38.18,0,0,0-.92-12.86,51.67,51.67,0,0,0-69.06-35.21c-20.9,8.3-33.49,29.77-31.54,52.17,2.21,25.34,7.57,95.95-1,99.08,45.89-16.25,68.84-17.21,103.25,0C576.65,318.37,582.46,247,584.22,227.56Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#f55f44"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.67,246.35a28,28,0,0,0-.79-10.16C571,218.55,553.8,205.5,533.27,205.5a46.87,46.87,0,0,0-16.22,2.86c-17.8,6.56-28.53,23.52-26.87,41.22,1.88,20,6.45,75.81-.89,78.29,39.09-12.84,58.64-13.6,88,0C570.23,318.1,575.18,261.67,576.67,246.35Z",
    transform: "translate(-184.74 -87.4)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M484.67,529.6s10.28,78,6,89.67-6.65,77.33-2.42,93.57,0,37.69,0,37.69l-5.44,16.89s-10.28,25.34,23,23.39c0,0,9.68.65,4.84-11s-2.42-59.13-2.42-59.13,6.65-86.42,12.1-94.87,8.47-96.17,8.47-96.17Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fdb797"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M472,785.63s-16.33-12.35-11.49-27.29,7.26-18.84,3.63-22.09-10.89-15.6,6-20.79c0,0,6,.65,20-19.49s12.7-45.49,47.19-70.18l3.63-63.68L533.07,516l55.05,4.55-12.7,106.57L495.56,720s-19.36,43.54-15.73,52S484.67,789.52,472,785.63Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M472.57,786.93s-16.33-12.35-11.49-27.29,7.26-18.84,3.63-22.09-10.89-15.6,6-20.79c0,0,6,.65,20-19.49s12.7-45.49,47.19-70.18l3.63-63.68-7.86-46.14,55.05,4.55L576,628.37,496.16,721.3s-19.36,43.54-15.73,52S485.28,790.82,472.57,786.93Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fdb797"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M606.89,566.89c-17.21-1-18.17-4.78-28.68-21s-29.64-1.91-29.64-1.91l-6.69-52.58,1,66.92c-30.59-15.3-70.75,2.87-70.75,2.87C454.88,469.37,452.6,468,467.3,432.09a199.48,199.48,0,0,1,10.5-20.73h0c6.06-10.94,11.37-20.78,10-28.1a10.56,10.56,0,0,0-1.41-3.75c-23.53-38.1-9.48-83.36,34.71-76.19,2.25.36,3.53.66,3.53.66h17.21c69.79-3.82,51.63,55.45,39.2,75.53-.33,1.21-.64,2.47-.92,3.75-2.08,9.48-2.75,20.85-2.41,33.22C579.48,478.93,606.89,566.89,606.89,566.89Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M606.89,565c-17.21-1-18.17-4.78-28.68-21S549.53,542,549.53,542l-7.65-52.58v66.92c-30.59-15.3-69.79,2.87-69.79,2.87-17.21-91.78-19.48-93.14-4.78-129.07a199.48,199.48,0,0,1,10.5-20.73h0c6.06-10.94,11.37-20.78,10-28.1a10.56,10.56,0,0,0-1.41-3.75c-23.53-38.1-9.48-83.36,34.71-76.19,2.25.36,3.53.66,3.53.66h17.21c69.79-3.82,51.63,55.45,39.2,75.53-.33,1.21-.64,2.47-.92,3.75-2.08,9.48-2.75,20.85-2.41,33.22C579.48,477,606.89,565,606.89,565Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#ff4f5c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M335.15,180.24h26.77a0,0,0,0,1,0,0v41.64a9,9,0,0,1-9,9h-8.72a9,9,0,0,1-9-9V180.24A0,0,0,0,1,335.15,180.24Z",
    fill: "#fdb797"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M591.33,344.24l72-112.93L627,142.4,602.11,152l20.08,75.53s-28.68,76.87-54.5,76.2Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#ff4f5c"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M519.89,284.68a44.09,44.09,0,0,0,26.77,0V269.56H519.89Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 348.53,
    cy: 153.47,
    r: 43.98,
    fill: "#fdb797"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.85,203.59s6.69,42.07,78.4,35.37l-2.87-24.86L551.44,194H524.67Z",
    transform: "translate(-184.74 -87.4)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M498.85,202.63s6.69,42.07,78.4,35.37l-2.87-24.86-22.95-20.08H524.67Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#f55f44"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 393.47,
    cy: 153.95,
    rx: 2.87,
    ry: 6.21,
    fill: "#fdb797"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.55,
    cy: 153.95,
    rx: 2.87,
    ry: 6.21,
    fill: "#fdb797"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M475.21,343.29l-72-112.93,36.33-87,24.86,9.56-20.08,73.62s28.68,76.87,54.5,76.2Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#ff4f5c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.38,377.59c-.33,1.21,4.14,2.47,3.86,3.75-2.08,9.48-2.75,20.85-2.41,33.22,1.69,61.15,28,146.73,29.1,150.29l2,.13s-27.41-88-29.14-150.42c-.34-12.37.32-23.74,2.41-33.22.28-1.28.58-2.53.92-3.75Z",
    transform: "translate(-184.74 -87.4)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M577.75,415.52,477.8,410.4h0c6.06-10.94,11.37-20.78,10-28.1,0,0,29.25,20,92.32,0C578.07,391.78,577.4,403.15,577.75,415.52Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.19,430.17a199.48,199.48,0,0,1,10.5-20.73h0c6.06-10.94,11.37-20.78,10-28.1-.24-1.34,7.58-1.84,6.21-1.84-2.89,0-7.65-1.91-10.5-1.91-1.36,0,1.18,2.41,1.41,3.75,1.33,7.32-4,17.16-10,28.1h0a199.48,199.48,0,0,0-10.5,20.73c-14.7,35.93-12.43,37.29,4.78,129.07,0,0,.95-.44,2.66-1.12C457.75,467.46,455.55,466,470.19,430.17Z",
    transform: "translate(-184.74 -87.4)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M577.75,414.56l-99.95-5.11h0c6.06-10.94,11.37-20.78,10-28.1,0,0,14.84,10.59,42.56,2.94,15.3,7.65,29.14,3.59,49.75-2.94C578.07,390.82,577.4,402.19,577.75,414.56Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#535461"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M475.43,343.65l4.3-5.26,9.08.48A17.36,17.36,0,0,0,475.43,343.65Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M592.07,343.65l-5.74-5.74-7.65,1A17.36,17.36,0,0,1,592.07,343.65Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "357.14 431.53 360.96 431.69 361.43 430.57 357.14 430.53 357.14 431.53",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "254.84 55.95 255.31 54.44 280.29 64.58 279.7 65.52 254.84 55.95",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "441.72 54.25 416.54 64.18 417.37 64.56 442.23 55 441.72 54.25",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M444.36,226.53l20.08-73.62h-2.87l-20.08,73.62s28.68,76.87,54.5,76.2h2.87C473,303.41,444.36,226.53,444.36,226.53Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M622.19,228.45l-20.08-75.53H605l20.08,75.53s-28.68,76.87-54.5,76.2h-2.87C593.5,305.32,622.19,228.45,622.19,228.45Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.33,
    cy: 648.61,
    rx: 18.19,
    ry: 44.66,
    fill: "url(#3aa49d9c-916f-4670-b217-2910ad731142-299)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M841.26,790.8,708.94,790v-2.23c0-23.75,19.24-28.55,43-28.56l46.31,0c23.75,0,43,4.77,43,28.52Z",
    transform: "translate(-184.74 -87.4)",
    fill: "url(#29fdbb02-504d-40fc-8c8b-89d40eb7543b-300)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M697.36,644.27l-5.41-.39c-23.95-1.72-40.62-10.19-49.57-25.19-17.1-28.65,1.18-70,2-71.76l1.44-3.2,59,0ZM653,554.6c-3.65,9.63-13,38.85-1.24,58.55,6.38,10.67,18.34,17.17,35.6,19.36l5.74-77.93Z",
    transform: "translate(-184.74 -87.4)",
    fill: "url(#875735f0-9451-4d18-8d7e-91aa5c4b50ca-301)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M851.06,644.21l-7.49-100.55,59,0,1.44,3.2c.79,1.75,19.1,43.09,2,71.75-8.94,15-25.61,23.49-49.55,25.23Zm4.22-89.69,5.81,77.92c17.26-2.2,29.21-8.71,35.59-19.39,11.76-19.71,2.37-48.92-1.29-58.55Z",
    transform: "translate(-184.74 -87.4)",
    fill: "url(#86201932-e8e2-4080-9e8f-200c3a4020d8-302)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M774.24,727.74h0a81.87,81.87,0,0,1-81.9-81.83l-.06-129.83L856,516l.06,129.83A81.87,81.87,0,0,1,774.24,727.74Z",
    transform: "translate(-184.74 -87.4)",
    fill: "url(#fba1422f-afa4-4f40-bd94-90e3ecf07106-303)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 555.47,
    y: 385.79,
    width: 65.55,
    height: 89.95,
    rx: 25,
    ry: 25,
    fill: "#f9d075"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M739,461.76s-7.44-13.49-3.79-26.4c0,0,15.72-4.21,26.39,8.14Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#f9d075"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M741.29,458.29s-5.53-10-2.82-19.64c0,0,11.69-3.13,19.63,6.06Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#ffe9a1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M808.88,458.29s5.53-10,2.82-19.64c0,0-11.69-3.13-19.63,6.06Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#ffe9a1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M811.16,461.76s7.44-13.49,3.79-26.4c0,0-15.72-4.21-26.39,8.14Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#f9d075"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M808.88,458.29s5.53-10,2.82-19.64c0,0-11.69-3.13-19.63,6.06Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#ffe9a1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M814.94,478q0,1.6-.14,3.18c-1.69,19.6-18.83,35-39.72,35-18.7,0-34.4-12.34-38.7-29a36.83,36.83,0,0,1-1.16-9.19c0-21.08,17.85-38.18,39.86-38.18S814.94,456.94,814.94,478Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#f9d075"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M741.12,496.27l-3-6.46h-12.4l7,6.18-5.05,1.68s41.82,44.91,92.63,0l-3.93-1.4,6.18-5.33L818,489.81l1.68-3.37-6.78.28-7.82,14.59L779,512.83Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#ffe9a1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 604.66,
    cy: 394.55,
    r: 3.65,
    fill: "#2b1f0e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 574.91,
    cy: 394.55,
    r: 3.65,
    fill: "#2b1f0e"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M814.81,481.2c-1.69,19.6-18.83,35-39.72,35-18.7,0-34.4-12.34-38.7-29,2,1.82,3.79,4.46,5.39,6.18a19.42,19.42,0,0,0,4,3.57c2.45,1.5,5.43,1.85,8.3,2,2.59.1,5.47-.06,7.32-1.88s2.06-4.47,3.12-6.73a11.42,11.42,0,0,1,8.46-6.17,14.3,14.3,0,0,1,10.31,2.53,7.54,7.54,0,0,1,2.06,2,19.64,19.64,0,0,1,1.41,3.43c2.31,5.6,9.77,7.85,15.4,5.61s9.36-7.89,10.75-13.79C813.17,482.78,813.72,481.32,814.81,481.2Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#ffe9a1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M774.52,499.92l-1.68,1.68a3.53,3.53,0,0,0,3.09,0Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#f25f1d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 550.48,
    y: 386.41,
    width: 79.72,
    height: 2.81,
    fill: "#535461"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 550.48,
    y: 389.22,
    width: 16,
    height: 14.88,
    fill: "#535461"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M566.34,389.08h18.53a0,0,0,0,1,0,0v3.13a10.06,10.06,0,0,1-10.06,10.06h-8.46a0,0,0,0,1,0,0V389.08A0,0,0,0,1,566.34,389.08Z",
    fill: "#535461",
    opacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M549.11,386.41H551a0,0,0,0,1,0,0v17.68a0,0,0,0,1,0,0h-1.93a6.21,6.21,0,0,1-6.21-6.21v-5.27a6.21,6.21,0,0,1,6.21-6.21Z",
    fill: "#535461"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M766.52,500.9s7.86,3.65,7.86-5.61",
    transform: "translate(-184.74 -87.4)",
    fill: "none",
    stroke: "#2b1f0e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M782.24,500.9s-7.86,3.65-7.86-5.61",
    transform: "translate(-184.74 -87.4)",
    fill: "none",
    stroke: "#2b1f0e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 589.78,
    cy: 404.09,
    rx: 3.09,
    ry: 3.93,
    fill: "#f25f1d"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.31,
    cy: 646.1,
    rx: 17.6,
    ry: 43.2,
    fill: "#cfd8dc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M699.87,644.76l-5.23-.38c-23.16-1.66-39.3-9.86-48-24.37-16.54-27.72,1.14-67.72,1.9-69.41l1.39-3.1,57.05,0ZM656.92,558c-3.53,9.31-12.59,37.58-1.2,56.64,6.17,10.32,17.74,16.61,34.44,18.73L695.71,558Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#cfd8dc"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M848.55,644.69l-7.25-97.27,57.05,0,1.4,3.1c.76,1.69,18.48,41.68,2,69.41-8.64,14.51-24.77,22.72-47.93,24.41Zm4.08-86.76,5.62,75.38c16.69-2.13,28.26-8.43,34.42-18.76,11.38-19.07,2.29-47.32-1.25-56.64Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#cfd8dc"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.39,622.4c-16.54-27.72,1.14-67.72,1.9-69.41l1.39-3.1,39.75,0,.17-2.25-42.63,0-1.39,3.1c-.76,1.69-18.44,41.7-1.9,69.41a43.08,43.08,0,0,0,10.83,12.16A42.91,42.91,0,0,1,649.39,622.4Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: -184.74,
    y: -87.4
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "668.62 460.02 671.14 460.14 670.92 470.4 668.63 470.53 668.62 460.02",
    opacity: 0.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 507.56,
    y: 460.09,
    width: 2.72,
    height: 10.51,
    opacity: 0.05
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M775,693.46c-8.36,0-15.35,14.32-17.14,33.51a79.51,79.51,0,0,0,16.35,1.69h0a79.44,79.44,0,0,0,17.92-2C790.31,707.6,783.34,693.45,775,693.46Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M510.26,433.31H668.66a0,0,0,0,1,0,0V558.9a79.2,79.2,0,0,1-79.2,79.2h0a79.2,79.2,0,0,1-79.2-79.2V433.31A0,0,0,0,1,510.26,433.31Z",
    fill: "#cfd8dc"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M701.37,647.05l-.05-125.59H695l.05,125.59a79.2,79.2,0,0,0,79.23,79.16h0c1.06,0,2.11,0,3.16-.07A79.19,79.19,0,0,1,701.37,647.05Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fff",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M790.11,758.5H760c3.09,12.47,8.68,20.8,15.06,20.79S787,771,790.11,758.5Z",
    transform: "translate(-184.74 -87.4)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M839.07,787.47l-128,.05h0c0-20.93,17-27.91,37.88-27.91l52.2,0c20.93,0,37.91,7,37.91,27.88Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#cfd8dc"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M757.62,755.91h-5c-23,0-41.59,8.64-41.58,31.62h5C716,764.55,734.64,755.92,757.62,755.91Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fff",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 588.81,
    cy: 526.13,
    r: 31.72,
    fill: "#da552f"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M777.78,597.67H762.45v31.72h6.34v-9.52h9a11.1,11.1,0,1,0,0-22.2Zm0,15.86h-9V604h9a4.76,4.76,0,0,1,0,9.52Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fff"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.15,
    cy: 437.74,
    rx: 13.14,
    ry: 15.91,
    fill: "#ffe9a1"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 543.31,
    cy: 433.81,
    rx: 13.14,
    ry: 15.91,
    fill: "#ffe9a1"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607,
    y: 189.82,
    width: 2.08,
    height: 11.78,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 791.73,
    y: 277.22,
    width: 2.08,
    height: 11.78,
    transform: "translate(891.15 -597.06) rotate(90)",
    fill: "#47e6b1"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 723,
    y: 283.82,
    width: 2.08,
    height: 11.78,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 907.73,
    y: 371.22,
    width: 2.08,
    height: 11.78,
    transform: "translate(1101.15 -619.06) rotate(90)",
    fill: "#47e6b1"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M864.51,176.15a2.55,2.55,0,0,1-1.42-3.08,1.22,1.22,0,0,0,.06-.28h0a1.28,1.28,0,0,0-2.29-.85h0a1.22,1.22,0,0,0-.14.25,2.55,2.55,0,0,1-3.08,1.42,1.22,1.22,0,0,0-.28-.06h0a1.28,1.28,0,0,0-.85,2.29h0a1.22,1.22,0,0,0,.25.14,2.55,2.55,0,0,1,1.42,3.08,1.22,1.22,0,0,0-.06.28h0a1.28,1.28,0,0,0,2.29.85h0a1.22,1.22,0,0,0,.14-.25,2.55,2.55,0,0,1,3.08-1.42,1.22,1.22,0,0,0,.28.06h0a1.28,1.28,0,0,0,.85-2.29h0A1.22,1.22,0,0,0,864.51,176.15Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#4d8af0",
    opacity: 0.3
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M643.51,382.15a2.55,2.55,0,0,1-1.42-3.08,1.22,1.22,0,0,0,.06-.28h0a1.28,1.28,0,0,0-2.29-.85h0a1.22,1.22,0,0,0-.14.25,2.55,2.55,0,0,1-3.08,1.42,1.22,1.22,0,0,0-.28-.06h0a1.28,1.28,0,0,0-.85,2.29h0a1.22,1.22,0,0,0,.25.14,2.55,2.55,0,0,1,1.42,3.08,1.22,1.22,0,0,0-.06.28h0a1.28,1.28,0,0,0,2.29.85h0a1.22,1.22,0,0,0,.14-.25,2.55,2.55,0,0,1,3.08-1.42,1.22,1.22,0,0,0,.28.06h0a1.28,1.28,0,0,0,.85-2.29h0A1.22,1.22,0,0,0,643.51,382.15Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#4d8af0",
    opacity: 0.3
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M379,421a2.55,2.55,0,0,1-1.42-3.08,1.22,1.22,0,0,0,.06-.28h0a1.28,1.28,0,0,0-2.29-.85h0a1.22,1.22,0,0,0-.14.25,2.55,2.55,0,0,1-3.08,1.42,1.22,1.22,0,0,0-.28-.06h0a1.28,1.28,0,0,0-.85,2.29h0a1.22,1.22,0,0,0,.25.14,2.55,2.55,0,0,1,1.42,3.08,1.22,1.22,0,0,0-.06.28h0a1.28,1.28,0,0,0,2.29.85h0a1.22,1.22,0,0,0,.14-.25,2.55,2.55,0,0,1,3.08-1.42,1.22,1.22,0,0,0,.28.06h0a1.28,1.28,0,0,0,.85-2.29h0A1.22,1.22,0,0,0,379,421Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fdd835",
    opacity: 0.3
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M193.26,542.61a2.55,2.55,0,0,1-1.42-3.08,1.22,1.22,0,0,0,.06-.28h0a1.28,1.28,0,0,0-2.29-.85h0a1.22,1.22,0,0,0-.14.25,2.55,2.55,0,0,1-3.08,1.42,1.22,1.22,0,0,0-.28-.06h0a1.28,1.28,0,0,0-.85,2.29h0a1.22,1.22,0,0,0,.25.14,2.55,2.55,0,0,1,1.42,3.08,1.22,1.22,0,0,0-.06.28h0a1.28,1.28,0,0,0,2.29.85h0a1.22,1.22,0,0,0,.14-.25,2.55,2.55,0,0,1,3.08-1.42,1.22,1.22,0,0,0,.28.06h0a1.28,1.28,0,0,0,.85-2.29h0A1.22,1.22,0,0,0,193.26,542.61Z",
    transform: "translate(-184.74 -87.4)",
    fill: "#fdd835",
    opacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.7,
    cy: 221.25,
    r: 4.16,
    fill: "#f55f44",
    opacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 538.25,
    cy: 4.16,
    r: 4.16,
    fill: "#f55f44",
    opacity: 0.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.25,
    cy: 56.16,
    r: 4.16,
    fill: "#f55f44",
    opacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 294.16,
    r: 4.16,
    fill: "#f55f44",
    opacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 779.9,
    cy: 202.29,
    r: 4.16,
    fill: "#f55f44",
    opacity: 0.3
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 826.36,
    cy: 338.03,
    r: 4.16,
    fill: "#4d8af0",
    opacity: 0.3
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 826.36,
    cy: 545.03,
    r: 4.16,
    fill: "#4d8af0",
    opacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.36,
    cy: 535.03,
    r: 4.16,
    fill: "#4d8af0",
    opacity: 0.3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.87,
    cy: 441.89,
    r: 4.16,
    fill: "#47e6b1",
    opacity: 0.3
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.48,
    cy: 217.18,
    r: 4.16,
    fill: "#47e6b1",
    opacity: 0.3
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.89,
    cy: 117.9,
    r: 4.16,
    fill: "#47e6b1",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAnalysis);
export default __webpack_public_path__ + "static/media/product-analysis.ee5f754b716dd1cb66314e680e5f2865.svg";
export { ForwardRef as ReactComponent };